module.exports = __webpack_public_path__ + "html/section-video-steps_02f90ea4e8a2cb25875f4a5594901644.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-video-steps.html
// module id = K1Xq
// module chunks = 52